import React,{ Component } from 'react';

class ProgressEllipses extends Component {
  constructor(){
    super();

    this.state = {text:''};
  }

  componentDidMount(){
    this.timer = window.setInterval(() => {
      if(this.state.text.length === 3){
        this.setState({text:''});
      } else {
        this.setState({text:this.state.text+'.'});
      }
    },250);
  }

  componentWillUnmount(){
    window.clearInterval(this.timer);
  }

  render(){
    return (
      <span>{this.state.text}</span>
    )
  }
}

export default ProgressEllipses;



// WEBPACK FOOTER //
// ./src/shared/components/ProgressEllipses/index.js